import { z } from 'zod/v4';

/**
 * When the widget was created, in ms since the epoch — the legacy envelope's twin
 * of a versioned widget's `meta.createdAt`, read by the legacy → v0 migration.
 * Absent or `null` on widgets created before the field existed: unknown, never
 * guessed.
 */
export const createdAtSchemaLegacy = z.number().int().nonnegative().nullish();
